@if (!(navigationService.useMobileNav$ | async)) {
    <div class="header">
        @if (branch.icon.icon) {
            <div class="header-media">
                <fui-icon class="header-media-object" [height]="branch.icon.height" [icon]="branch.icon.icon"
                          id="icon" [width]="branch.icon.width"></fui-icon>
            </div>
        }
        <div class="header-label">
            <div class="header-label-title" id="title">
                {{ branch.title | translate }}
            </div>
        </div>
    </div>
}
<div class="links">
    @for (link of branch.links; track link; let index = $index) {
        @if (link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE) {
            <fui-navigation-group id="group-{{index}}" [group]="link"></fui-navigation-group>
        }
        @if (!link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE) {
            <fui-navigation-link id="link-{{index}}" [link]="link"></fui-navigation-link>
        }
    }
</div>
